export const complaintCategoryOption = [
  {
    label: "政治反动类",
    value: 1
  },
  {
    label: "暴恐类",
    value: 2
  },
  {
    label: "网络暴力",
    value: 9
  },
  {
    label: "赌博信息类",
    value: 3
  },
  {
    label: "淫秽色情类",
    value: 4
  },
  {
    label: "诈骗敲诈类",
    value: 5
  },
  {
    label: "涉未成年人",
    value: 6
  },
  {
    label: "垃圾广告",
    value: 7
  },
  {
    label: "侵权投诉",
    value: 8
  },
  {
    label: "网络谣言",
    value: 10
  },
  {
    label: "其他",
    value: 11
  }
];
